// Earliest date a dataset expiry picker may offer, as the YYYY-MM-DD an
// <input type="date"> takes for `min`. Tomorrow, not today: the picked date is
// sent as midnight UTC, so "today" is already in the past and the backend
// rejects it (an expiry ends in irreversible destruction).
export function minExpiryDate(now: Date = new Date()): string {
  const tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
  const mm = String(tomorrow.getMonth() + 1).padStart(2, "0");
  const dd = String(tomorrow.getDate()).padStart(2, "0");
  return `${tomorrow.getFullYear()}-${mm}-${dd}`;
}
